/**
 * The words of a list row's Marks column (piece 13; decisions 9720, 10070; T3164,
 * T3457): the mark's own word, which the export and a view's conditions read,
 * and the sentence each failing record's line reads in the hover. Spread into the one string lookup.
 */
export const LIST_MARK_STRINGS = {
  'listMarks.column': 'Marks',
  'listMarks.suggestions': 'Has Suggestions',
  'listMarks.missingW9': 'Missing W-9',
  'listMarks.noTaxExemptCertificate': 'No Tax Exempt Certificate',
  'listMarks.w9.absent': 'This vendor has no W-9 on file. Open its Vendor tile to upload one.',
  'listMarks.w9.rejected': 'This vendor’s W-9 was rejected, so none is on file. Open its Vendor tile to upload another.',
  'listMarks.w9.pendingApproval': 'This vendor’s W-9 is awaiting approval. Open its Vendor tile to review it.',
  'listMarks.certificate.none': 'The site {site} is a tax exempt customer and holds no certificate in force. Open the Sites tile to add one.',
  'listMarks.certificate.expired': 'Every tax exempt certificate the site {site} holds has expired. Open the Sites tile to add a new one.',
} as const;
